import { render, staticRenderFns } from "./PMDashboardForm.vue?vue&type=template&id=24c95ca0&scoped=true&"
import script from "./PMDashboardForm.vue?vue&type=script&lang=js&"
export * from "./PMDashboardForm.vue?vue&type=script&lang=js&"
import style0 from "./PMDashboardForm.vue?vue&type=style&index=0&id=24c95ca0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c95ca0",
  null
  
)

export default component.exports